export default __webpack_public_path__ + "static/media/034-katana.ea74722e.svg";